module.exports = __webpack_public_path__ + "img/PS25.ca7aae93.png";